import { v4 as UUID } from 'uuid';

import { VHSEvent } from '../typings';
import { ConfigState } from '../store/config';

export const VHSService = {
  async sendEvent(config: Partial<ConfigState>, event: VHSEvent) {
    if (!config.vhsApiUrl || !config.vhsApiKey || !config.getAccessToken) {
      throw new Error('The vhsApiUrl or vhsApiKey or getAccessToken settings were not provided in the configuration.');
    }

    let calls = 0;
    let vhsResponse: any | null = null;
    const apiRetryAttempts = config.videoApiRetryAttempts || 2;

    while (calls <= apiRetryAttempts && vhsResponse === null) {
      calls += 1;
      const forceRefresh = calls > 1;

      try {
        const { accessToken, tokenType } = await config.getAccessToken({ forceRefresh });

        const headers: Record<string, string> = {
          Authorization: `${tokenType} ${accessToken}`,
          platform: 'webvideoplayer',
          'content-type': 'application/json',
          'platform-version': config.version || '',
          'x-api-key': config.vhsApiKey,
          'x-transaction-id': UUID(),
        };

        if (config.useBodwebHeader) headers['bodweb'] = 'true';

        const response = await fetch(config.vhsApiUrl, {
          headers,
          keepalive: true,
          method: 'POST',
          body: JSON.stringify(event),
        });

        const vhsResponseJSON = await response.json();

        if (vhsResponseJSON.message === 'Invalid Akamai Token' || response.status === 401)
          throw new Error('VHS failed due to invalid token');

        vhsResponse = vhsResponseJSON;
      } catch (error) {
        console.log(`[Video Player] ${error}`);
      }
    }
  },
};
